import React, { Component, useEffect } from 'react';
import "aos/dist/aos.css";
import Aos from 'aos';
import '../carousel2.css';
let Pic1 = 'https://sopassets.pages.dev/sop/1.jpg'; 
let Pic2 = 'https://sopassets.pages.dev/sop/3.jpg'; 
let Pic3 = 'https://sopassets.pages.dev/sop/6.jpeg'; 

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}


class Carousel2 extends Component {




    render() {
        return (
            <div class="cMain">
                <div class="carousel__container">
                    <div class="carousel__item">
                        <img src={Pic1} class="carousel__image"/>
                    </div>                    
                    <div class="carousel__item">
                        <img src={Pic2} class="carousel__image"/>
                    </div>
                    <div class="carousel__item">
                        <img src={Pic3} class="carousel__image"/>
                    </div>
                   
                </div>
            </div>
        )
    }
}

export default Carousel2;

